var _style, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdutoSemFoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.85;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#DADADA;}\n\t.st3{fill:#C6C6C6;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 256.9916,
    cy: 256.9916,
    r: 256.9916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2D2D2"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 513.98,
    height: 513.98
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.14,123.46c1.61,14.24,3.18,27.83,4.69,41.42c1.81,16.23,3.55,32.47,5.39,48.7 c0.77,6.77,6.5,11.64,12.78,11.07c6.74-0.61,11.66-6.09,11.02-13.09c-1.14-12.41-2.68-24.79-4.07-37.18 c-2.58-23.05-5.25-46.09-7.72-69.15c-0.83-7.77,4.53-13.62,12.38-13.65c23.59-0.08,47.17-0.08,70.76,0 c8.01,0.03,13.34,6.01,12.46,13.94c-3.33,29.99-6.74,59.97-10.12,89.95c-0.56,4.96-1.18,9.91-1.64,14.87 c-0.71,7.8,3.77,13.58,10.92,14.28c6.67,0.65,12.15-4.57,12.98-12.1c3.25-29.48,6.57-58.95,9.94-89.08 c21.77,13.31,38.56,30.83,51.2,52.33c17.23,29.32,24.36,61.05,22.34,95.2c-95.61,0-190.89,0-286.78,0 c-1.9-28.45,2.98-55.67,15.11-81.55C139.69,161.91,158.76,139.82,185.14,123.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.44,295.19c49.41,0,98.81-0.01,148.22,0.01c10.93,0,19.02,7.59,19.1,17.79 c0.08,9.51-7.4,17.52-16.9,18.09c-1,0.06-2,0.04-2.99,0.04c-98.56,0-197.13,0-295.69,0c-9.97,0-16.92-4.87-19.21-13.38 c-2.92-10.92,4.97-21.85,16.26-22.51c1.37-0.08,2.74-0.04,4.12-0.04C157.37,295.19,206.4,295.19,255.44,295.19z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.26,370.67c1.84-0.4,4.34-0.65,6.83-0.65c3.89,0,6.98,0.55,9.12,2.59c1.99,1.75,2.89,4.54,2.89,7.38 c0,3.64-1.1,6.23-2.84,8.07c-2.09,2.24-5.43,3.24-8.17,3.24c-0.45,0-0.85,0-1.3-0.05v12.51h-6.53V370.67z M96.79,385.97 c0.35,0.05,0.7,0.05,1.1,0.05c3.29,0,4.73-2.34,4.73-5.48c0-2.94-1.2-5.23-4.24-5.23c-0.6,0-1.2,0.1-1.59,0.25V385.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.04,370.67c2.04-0.4,4.63-0.65,7.13-0.65c3.59,0,6.83,0.55,8.97,2.49c2.04,1.84,2.69,4.09,2.69,6.98 c0,3.59-1.79,6.83-5.18,8.37v0.1c2.29,0.95,3.44,3.04,4.09,6.68c0.65,3.74,1.54,7.87,2.14,9.12h-6.83 c-0.45-0.95-1.2-4.34-1.69-8.07c-0.6-4.14-1.64-5.33-3.79-5.33h-1v13.41h-6.53V370.67z M119.56,385.32h1.2 c2.84,0,4.44-2.29,4.44-5.23c0-2.89-1.15-4.88-4.04-4.98c-0.6,0-1.25,0.05-1.59,0.2V385.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M156.29,386.37c0,12.66-4.48,17.79-10.86,17.79c-7.62,0-10.61-8.07-10.61-17.29 c0-9.17,3.64-17.09,11.11-17.09C154,369.77,156.29,378.69,156.29,386.37z M141.59,386.97c0,7.62,1.45,11.51,4.09,11.51 c2.79,0,3.84-4.98,3.84-11.81c0-5.88-0.9-11.21-3.89-11.21C143.03,375.46,141.59,379.74,141.59,386.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.42,370.67c1.64-0.4,4.04-0.65,6.63-0.65c4.24,0,7.18,1,9.32,2.99c2.89,2.59,4.39,7.03,4.39,13.55 c0,6.78-1.74,11.61-4.68,14.2c-2.29,2.14-5.58,3.24-10.22,3.24c-2.09,0-4.14-0.2-5.43-0.4V370.67z M166.95,398.58 c0.35,0.1,0.8,0.1,1.15,0.1c3.14,0,5.88-3.09,5.88-12.36c0-6.88-1.79-11.06-5.73-11.06c-0.45,0-0.9,0-1.3,0.15V398.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.22,370.17V392c0,4.93,1.44,6.43,3.19,6.43c1.89,0,3.24-1.35,3.24-6.43v-21.83h6.53v20.68 c0,8.62-3.29,13.31-9.72,13.31c-7.03,0-9.77-4.83-9.77-13.26v-20.73H191.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.44,376.2h-5.93v-6.03h18.44v6.03h-5.98v27.56h-6.53V376.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.58,386.37c0,12.66-4.49,17.79-10.86,17.79c-7.62,0-10.61-8.07-10.61-17.29 c0-9.17,3.64-17.09,11.11-17.09C246.28,369.77,248.58,378.69,248.58,386.37z M233.88,386.97c0,7.62,1.45,11.51,4.09,11.51 c2.79,0,3.84-4.98,3.84-11.81c0-5.88-0.9-11.21-3.89-11.21C235.32,375.46,233.88,379.74,233.88,386.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M259.89,397.08c1.35,0.75,3.69,1.3,5.53,1.3c3.04,0,4.58-1.59,4.58-3.79c0-2.44-1.5-3.64-4.34-5.48 c-4.58-2.79-6.33-6.33-6.33-9.37c0-5.38,3.59-9.87,10.57-9.87c2.24,0,4.33,0.6,5.28,1.2l-1.05,5.63c-0.95-0.6-2.39-1.15-4.24-1.15 c-2.79,0-4.14,1.69-4.14,3.49c0,1.99,1,3.04,4.58,5.23c4.49,2.69,6.08,6.08,6.08,9.62c0,6.13-4.54,10.17-11.06,10.17 c-2.69,0-5.28-0.7-6.43-1.35L259.89,397.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.42,389.01h-7.62v9.07h8.62v5.68h-15.15v-33.59h14.6v5.68h-8.07v7.72h7.62V389.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M320.43,392c-0.2-3.19-0.4-7.53-0.35-11.11h-0.1c-0.6,3.59-1.5,7.72-2.14,10.32l-2.94,12.01h-4.58 l-2.79-11.81c-0.65-2.69-1.54-6.88-2.09-10.51h-0.1c-0.1,3.64-0.35,7.87-0.5,11.21l-0.6,11.66h-5.58l2.39-33.59h6.93l2.69,12.16 c0.9,4.24,1.74,7.97,2.34,11.76h0.15c0.5-3.74,1.25-7.53,2.09-11.76l2.69-12.16h6.88l2.04,33.59h-5.83L320.43,392z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M339.57,370.17h14.6v5.68h-8.07v8.62h7.58v5.43h-7.58v13.85h-6.53V370.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M378.93,386.37c0,12.66-4.49,17.79-10.86,17.79c-7.62,0-10.61-8.07-10.61-17.29 c0-9.17,3.64-17.09,11.11-17.09C376.64,369.77,378.93,378.69,378.93,386.37z M364.23,386.97c0,7.62,1.45,11.51,4.09,11.51 c2.79,0,3.84-4.98,3.84-11.81c0-5.88-0.9-11.21-3.89-11.21C365.68,375.46,364.23,379.74,364.23,386.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M386.36,376.2h-5.93v-6.03h18.44v6.03h-5.98v27.56h-6.53V376.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M421.49,386.37c0,12.66-4.49,17.79-10.86,17.79c-7.62,0-10.61-8.07-10.61-17.29 c0-9.17,3.64-17.09,11.11-17.09C419.2,369.77,421.49,378.69,421.49,386.37z M406.79,386.97c0,7.62,1.45,11.51,4.09,11.51 c2.79,0,3.84-4.98,3.84-11.81c0-5.88-0.9-11.21-3.89-11.21C408.23,375.46,406.79,379.74,406.79,386.97z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdutoSemFoto);
export default __webpack_public_path__ + "static/media/produto_sem_foto.2ca49e70aa8f7713f50e0251962a28c5.svg";
export { ForwardRef as ReactComponent };